const e=s=>0===s.subcategories.length?[]:s.subcategories.reduce(((s,t)=>[...s,t,...e(t)]),[]);export{e as getAllSubcategories};
